import React, { FC } from "react";

interface QuoteType {
    quoteText: string;
    quoteBy?: string;
    position?: string;
    paddingx?: string;
}
const Quote: FC<QuoteType> = ({ quoteText, quoteBy, position, paddingx }) => {
    return (
        <section className={`bg-blue-color py-2 sm:py-5 my-16 text-white rounded-xl stroke-pattern ${paddingx}`}>
            <blockquote className="border-0 p-0">
                <p className="quote p-0">{quoteText}</p>
                <p className="quoteby mt-8 mb-0">{quoteBy}</p>
                <p className="quoteby m-0">{position}</p>
            </blockquote>
        </section>
    );
};

export default Quote;
